'use strict';

import React, { Component } from 'react';
import CardPage from '../../commonModules/layouts/CardPage';
import { Grid, Box, TableRow, TableHead, TableCell, Typography, Button,TableBody } from '@material-ui/core';
import { InputSelect } from '../../commonModules/interface/form-input-inline';
import { TableLayout } from '../Menu/Stock/containers/Layout';

var Moment = require('moment'),
    $ = require('jquery');

class UserDetails extends Component{
        tabledata = [{id: ''}];
        //tabledata.push();
        state = {
            //Initiate Default User
            paygoUser: this.tabledata,
            options: [
                {
                    id: "",
                    value: ""
                }
            ],
            value: "",
            statusPaygo: "",
            paygoId: "",
            lastCode: "",
            lastCodeUpdate: "",
            lastUpdate: "",
            nextCode: "",
            nextCodeUpdate: "",
            softVersion: "",
            msgInfoSynchronisation: "",
            upgradeBackMsgInfo: "",
            upgradeFrontMsgInfo: "",
            synchronisationMsgInfo: "",
            validateCodeList: [],
            codeList: []
        }
    onChange= async (e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});

        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'paygoIngo class';
        var url = "/user/paygo/Info?paygo=" + paygoId;
        console.log(url);

        this.getPaygoInfoRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var paygoInfo = "";
            var lastCode = "";
            var lastCodeUpdate = "";
            var lastUpdate = "";
            var nextCode = "";
            var softVersion = "";
            var nextCodeUpdate = "";
            var synchronisationMsgInfo = "";
            var validateCodeList = [];
            var codeList = [];

            try {
                var data = result; //var data = JSON.parse(result);
                console.log(result);
                console.log(data);

                var d = new Date();
                var offSet = d.getTimezoneOffset();

                var datePoint = Date.parse(data.lastCodeUpdate);
                var lastC = new Date(datePoint - 1000 * 60 * offSet);

                var nextP = Date.parse(data.nextCodeUpdate);
                var nextUP = new Date(nextP - 1000 * 60 * offSet);

                var lastP = Date.parse(data.lastUpdate);
                var lastUp = new Date(lastP - 1000 * 60 * offSet);

                paygoInfo = data.status;
                lastCode = data.lastCode;
                lastCodeUpdate = lastC.toISOString();
                lastUpdate = lastUp.toISOString();
                nextCode = data.nextCode;
                nextCodeUpdate = nextUP.toISOString();
                validateCodeList = data.validateCodeList;
                codeList = data.codeList;
                softVersion = data.softVersion;
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            this.setState({
                statusPaygo: paygoInfo,
                paygoId: paygoId,
                lastCode: lastCode,
                lastCodeUpdate: lastCodeUpdate,
                lastUpdate: lastUpdate,
                nextCode: nextCode,
                nextCodeUpdate: nextCodeUpdate,
                validateCodeList: validateCodeList,
                codeList: codeList,
                softVersion: softVersion
            });
        }.bind(this));
    }
    componentDidMount() {
        //Get Data From paygo User
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'paygoUser class';
        var url = "/user/paygoboxlist";
        var testTime = Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var paygoUserTmp = [];
            var optionTmp = [];
            try {
                var data = result; //var data = JSON.parse(result);
                console.log(result);
                console.log(data);
                console.log(data.userList);

                for (var i = 0; i < data.userList.length; i += 1) {
                    console.log(data.userList[i]);

                    var datePoint = Date.parse(data.userList[i].lastConnexion);
                    var d = new Date();
                    var offSet = d.getTimezoneOffset();
                    var lastC = new Date(datePoint - 1000 * 60 * offSet);

                    var nextP = Date.parse(data.userList[i].nextPaiement);
                    var nextPP = new Date(nextP - 1000 * 60 * offSet);

                    var lastP = Date.parse(data.userList[i].lastPaiement);
                    var lastPP = new Date(lastP - 1000 * 60 * offSet);

                    var nameClass = "";
                    if (data.userList[i].status === "OK") {
                        nameClass = "success";
                    }
                    if (data.userList[i].status === "PaygBlocked") {
                        nameClass = "danger";
                    }
                    if (data.userList[i].status === "NoConnection") {
                        nameClass = "warning";
                    }
                    if (data.userList[i].status === "InitPAYG") {
                        nameClass = "info";
                    }

                    paygoUserTmp.push({
                        id: data.userList[i].id,
                        lastConnexion: lastC.toISOString(),
                        name: data.userList[i].name,
                        lastPaiement: lastPP.toISOString(),
                        nextPaiement: nextPP.toISOString(),
                        status: data.userList[i].status,
                        nextCode: data.userList[i].nextCode,
                        classN: nameClass
                    });
                    optionTmp.push({id: data.userList[i].name, value: data.userList[i].name})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }

            console.log(paygoUserTmp);
            this.setState({paygoUser: paygoUserTmp, options: optionTmp, upgradeBackMsgInfo: "", synchronisationMsgInfo: ""});
        }.bind(this));
    }
    componentWillUnmount() {
        try {
            this.serverRequest.abort();
            this.getPaygoInfoRequest.abort();
            this.synchroPwdRequest.abort();
            this.upgradeBackVersionRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    onSynchronisationClickHandler= async (e) => {
        e.preventDefault();
        if (this.state.value === "") {
            console.log("[ERROR], No Box select");
            this.setState({synchronisationMsgInfo: "Pas de paygo selectionné", upgradeBackMsgInfo: ""});
            return;
        }

        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'paygoSync class';

        var url = "/user/paygo/sync/box/pwd?paygo=" + this.state.value;
        console.log(url);

        this.synchroPwdRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  de synchronisation');
            console.log(result);
            var msg = "";
            try {
                var data = result; //var data = JSON.parse(result);
                msg = data.msg
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({synchronisationMsgInfo: msg, upgradeBackMsgInfo: ""});
        }.bind(this));

    }
    onUpgradeBackClickHandler= async (e) => {
        e.preventDefault();
        if (this.state.value === "") {
            console.log("[ERROR], No Box select");
            this.setState({upgradeBackMsgInfo: "Pas de paygo selectionné", synchronisationMsgInfo: ""});
            return;
        }

        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'upgradeBackVersionRequest class';
        var url = "/user/paygo/upgrade/back/paygo?paygo=" + this.state.value;
        console.log(url);

        this.upgradeBackVersionRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  de synchronisation');
            console.log(result);
            var msg = "";
            try {
                var data = result; //var data = JSON.parse(result);
                msg = data.msg
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({upgradeBackMsgInfo: msg, synchronisationMsgInfo: ""});
        }.bind(this));

    }
    onUpgradeFrontClickHandler= async (e) => {
        e.preventDefault();
        if (this.state.value === "") {
            console.log("[ERROR], No Box select");
            this.setState({upgradeFrontMsgInfo: "Pas de paygo selectionné"});
            return;
        }

        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'upgradeFrontVersionRequest class';
        var url = "/user/paygo/upgrade/front/paygo?paygo=" + this.state.value;
        console.log(url);

        this.upgradeBackVersionRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  de synchronisation');
            console.log(result);
            var msg = "";
            try {
                var data = result; //var data = JSON.parse(result);
                msg = data.msg
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({upgradeFrontMsgInfo: msg});
        }.bind(this));

    }
    render() {
        var validateCodeListJsx = [];
        var codeListJsx = [];
        if (this.state.codeList) {
            this.state.codeList.forEach(function(user) {
                codeListJsx.push(
                    <TableRow className="">
                        <TableCell>{user.idCode}</TableCell>
                        <TableCell>{user.code}</TableCell>
                        <TableCell>{user.kwh}</TableCell>
                        <TableCell>{user.day}</TableCell>
                    </TableRow>
                );
            }.bind(this));
        }
        if (this.state.validateCodeList) {
            this.state.validateCodeList.forEach(function(user) {
                validateCodeListJsx.push(
                    <TableRow className="">
                        <TableCell>{user.receivedtime}</TableCell>
                        <TableCell>{user.systime}</TableCell>
                        <TableCell>{user.idCode}</TableCell>
                        <TableCell>{user.code}</TableCell>
                        <TableCell>{user.kwh}</TableCell>
                        <TableCell>{user.day}</TableCell>
                        <TableCell>{user.typeCode}</TableCell>
                    </TableRow>
                );
            }.bind(this));
        }
        console.log('[INFO], render fonction Main PAYG');
        console.log('[INFO], option: ');
        var valueList = this.state.options;

        //Order by name
        valueList.sort(function(a, b) {
            if (a.value>b.value){
              return -1;
            }
            if (a.value < b.value){
              return 1;
            }
            return 0;
        });

        return (
            <CardPage title="Liste des utilisateurs" subtitle="Etat des conexion utilisateurs" >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputSelect 
                            label="Rechercher"
                            value={this.state.value} 
                            onChange={this.onChange}
                            options={valueList.map( optionval => <option value={optionval.id}>{optionval.value}</option> )}
                        >
                            
                        </InputSelect>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="text-right">
                            <p className="c-gray">PAYGO Box Number :</p>
                            <p className="c-gray">Last Update:</p>

                            <h4>Status</h4>

                            <p className="c-gray">Version Software:</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="i-to">
                            <p className="c-gray">{this.state.paygoId}</p>
                            <p className="c-gray">{this.state.lastUpdate}</p>

                            <h4>{this.state.statusPaygo}</h4>

                            <p className="c-gray">{this.state.softVersion}</p>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="bgm-amber brd-2 p-15">
                            <div className="c-white m-b-5">Last Code</div>
                            <h5 className="m-0 c-white f-300">{this.state.lastCode}</h5>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                    
                        <div className="bgm-blue brd-2 p-15">
                            <div className="c-white m-b-5">Last Update</div>
                            <h5 className="m-0 c-white f-300">{this.state.lastCodeUpdate}</h5>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="bgm-green brd-2 p-15">
                            <div className="c-white m-b-5">Next Code</div>
                            <h5 className="m-0 c-white f-300">{this.state.nextCode}</h5>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="bgm-red brd-2 p-15">
                            <div className="c-white m-b-5">Next Update</div>
                            <h5 className="m-0 c-white f-300">{this.state.nextCodeUpdate}</h5>
                        </div>
                    </Grid>
                    
                </Grid>
                <Box p={2}>
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th">Cloud Time</TableCell>
                                <TableCell component="th">System Time</TableCell>
                                <TableCell component="th">Id Code</TableCell>
                                <TableCell component="th">code</TableCell>
                                <TableCell component="th">kWh</TableCell>
                                <TableCell component="th">day</TableCell>
                                <TableCell component="th">Synchronisation</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {validateCodeListJsx}
                        </TableBody>
                    </TableLayout>

                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th">Id Code</TableCell>
                                <TableCell component="th">Code</TableCell>
                                <TableCell component="th">kwh</TableCell>
                                <TableCell component="th">Day</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {codeListJsx}
                        </TableBody>
                    </TableLayout>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Box p={2}>
                                <Typography variant="h4">Synchronisation de la liste des mot de passe</Typography>
                                <Typography variant="caption">Cette synchronisation peut prendre du temps</Typography>
                                <Box p={1}>
                                    <Button onClick={this.onSynchronisationClickHandler}>
                                        Synchronisation
                                    </Button>
                                </Box>
                                <p className="c-red">{this.state.synchronisationMsgInfo}</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box p={2}>
                                <Typography variant="h4">Mise à jour Software Back</Typography>
                                <Typography variant="caption">Cette synchronisation peut prendre du temps</Typography>
                                <Box p={1}>
                                    <Button onClick={this.onUpgradeBackClickHandler}>
                                    Upgrade Back
                                    </Button>
                                </Box>
                                <p className="c-red">{this.state.upgradeBackMsgInfo}</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box p={2}>
                                <Typography variant="h4">Mise à jour Software Front</Typography>
                                <Typography variant="caption">Cette synchronisation peut prendre du temps</Typography>
                                <Box p={1}>
                                    <Button onClick={this.onUpgradeFrontClickHandler}>
                                    Upgrade Front
                                    </Button>
                                </Box>
                                <p className="c-red">{this.state.upgradeFrontMsgInfo}</p>
                            </Box>
                        </Grid>
                        
                    </Grid>
                        {/* <div className="p-25">
                            <h4 className="c-green f-400">Synchronisation de la liste des mot de passe</h4>
                            <p className="c-gray">Cette synchronisation peut prendre du temps</p>

                            <br/>

                            <div className="btn-colors btn-demo">
                                <button className="btn bgm-amber waves-effect" onClick={this.onSynchronisationClickHandler}>Synchronisation</button>
                            </div>
                            <p className="c-red">{this.state.synchronisationMsgInfo}</p>
                        </div> */}
                        {/* <div className="p-25">
                            <h4 className="c-green f-400">Mise à jour Software Back</h4>
                            <p className="c-gray">Cette synchronisation peut prendre du temps</p>

                            <br/>

                            <div className="btn-colors btn-demo">
                                <button className="btn bgm-amber waves-effect" onClick={this.onUpgradeBackClickHandler}>Upgrade Back</button>
                            </div>
                            <p className="c-red">{this.state.upgradeBackMsgInfo}</p>
                        </div> */}
                        {/* <div className="p-25">
                            <h4 className="c-green f-400">Mise à jour Software Front</h4>
                            <p className="c-gray">Cette synchronisation peut prendre du temps</p>

                            <br/>

                            <div className="btn-colors btn-demo">
                                <button className="btn bgm-amber waves-effect" onClick={this.onUpgradeFrontClickHandler}>Upgrade Front</button>
                            </div>
                            <p className="c-red">{this.state.upgradeFrontMsgInfo}</p>
                        </div> */}
                </Box>
            </CardPage>

        );
    }
};

export default UserDetails;